import $ from 'jquery'
import _ from 'underscore'
import { track } from '@/analytics/trackAsync'
import imgix from 'imgix'

interface RecommendedItem {
  itemType: 'ITEM'
  value: number
  creationDate: string
  id: string
  description: string
  url: string
  imageUrl: string
  profileData: null
}

interface BaseItem {
  itemType: 'ITEM'
  value: null
  creationDate: string
  id: string
  description: string
  url: string
  imageUrl: string
  profileData: null
}

interface RecommendationsApiSuccessResponse {
  action: 'otherusersalsoviewed'
  userid: null
  sessionid: null
  recommendedItems: RecommendedItem[]
  tenantid: 'paperculture'
  baseitem: BaseItem
}

interface RecommendationsApiError {
  code: number
  content: null
  message: string
}

type RecommendationsApiErrorResponse = RecommendationsApiError[]

type RecommendationsApiResponse =
  | RecommendationsApiSuccessResponse
  | RecommendationsApiErrorResponse

export const showEasyrecRecommendations = () => {
  // easyrec is only deployed on www
  $.get(
    'https://www.paperculture.com/easyrec/api/1.1/json/otherusersalsoviewed?tenantid=paperculture&apikey=13f99b671fc70802b81321528b41a424' +
      '&itemtype=ITEM&requesteditemtype=ITEM&actiontype=VIEW&numberOfResults=15&itemid=' +
      window.item!.code
  ).done(function (data: RecommendationsApiResponse) {
    if (!('recommendedItems' in data)) {
      // Bail on error response
      return
    }

    // Extracts the format code and family code from the product code for strings only containing the code
    const familyCodePattern = /^[A-Z]*(\d+)(?:[A-Z]+?(PS|TY)?)-/
    const families: string[] = []

    // Matches a family number anywhere in an image URL
    const looseFamilyCodePattern = /[/._][A-Z]*(\d+)(?:[A-Z]+?(PS|TY)?)-/
    _.each($('#prod-suggestions .prod-and-title img'), function (img) {
      const $img = $(img)
      const src = ($img.attr('data-src') || $img.attr('src')) as string
      // Accumulate a list of families for We Also Suggest products so we don't have duplicates
      families.push(src.match(looseFamilyCodePattern)![1]!)
    })

    const redirectUrlFromTrackingUrlPattern = /u=(.*)/
    const exclusions = /D[HB]1922A-X/
    // Get a list of items with only the first item from each family to remove color duplicates
    const items = data.recommendedItems.reduce<RecommendedItem[]>(function (
      uniqueFamilyItems,
      item
    ) {
      // Filter out duplicates within the same family
      const family = item.id.match(familyCodePattern)![1]!
      if (exclusions.test(item.id)) {
        // Do nothing
      } else if (!_.contains(families, family)) {
        families.push(family)
        uniqueFamilyItems.push(item)
      }

      return uniqueFamilyItems
    }, [])

    // Show recommendations if there are at least 2 unique families
    if (items.length >= 2) {
      const $customersAlsoViewed = $('#customers-also-viewed')
      $('<hr class="customers-also-viewed">').insertBefore($customersAlsoViewed)
      const $products = $customersAlsoViewed
        .append(
          '<div class="row">' +
            '<div class="related-products">' +
            '<h3 class="prod-section-title">Customers Also Viewed</h3>' +
            '</div></div>'
        )
        .find('.related-products')

      $.each(items, function (i, item) {
        if (i == 8) {
          // break after displaying 8 items
          return false
        }

        const $item = $(
          '<a class="prod-and-title">' +
            '<div class="responsive-container rsp-square">' +
            '<div class="rsp-inner rsp-bottom">' +
            '<img>' +
            '</div>' +
            '</div>' +
            '<div class="prod-title"></div>' +
            '</a>'
        )
        // There's a bug that adds :-1 for the port on the tracking URL
        const trackingUrl = item.url
          .replace(':-1', '')
          // Redirect to the same environment that we're currently in
          .replace(
            encodeURIComponent('https://www.paperculture.com'),
            window.location.origin
          )
        const targetPage = decodeURIComponent(
          redirectUrlFromTrackingUrlPattern.exec(trackingUrl)![1]!
        )
        $item.attr(
          'href',
          targetPage
            // The tracking redirect should also be forced to HTTPS
            .replace('http://', 'https://')
        )
        // On click, go to the tracking URL, which redirects to target URL so that the href on the page is
        // the actual target URL. This ensures that search engines like Google will crawl the target
        // page instead of seeing and visiting the tracking URL, which would skew click data.
        $item.on('click', function (e) {
          e.preventDefault()
          const isMiddleClick = e.which === 2
          if (e.ctrlKey || e.shiftKey || e.metaKey || isMiddleClick) {
            // Detect if the user trying to open the link in a new tab or window
            window.open(trackingUrl, '_blank')
          } else {
            window.location.href = trackingUrl
          }
        })
        $item.find('.prod-title').text(item.description)
        $item.find('img').attr({
          class: 'imgix-fluid',
          alt: item.description,
          // Images paths are to huge images and are all relative.
          // Prepend imgix domain so imgix.js will load an optimized image.
          'data-src':
            '//paperculture.imgix.net' +
            item.imageUrl
              // Replace old image URL in existing data to use 651 image, since we're serving with imgix
              // and want to consistently use the same master image URL to reduce our bill.
              .replace('.CA.220.', '.PR.651.')
              .replace(/^https?:\/\/[^.]+\.paperculture\.com/, '')
        })
        $products.append($item)

        imgix.fluid($item.get(0), imgix.pcDefaults)
      })

      // Analytics tracking to compare we also suggest to these related products
      const addTracking = function ($elements: JQuery, action: string) {
        $elements.on('click', function () {
          track(
            action,
            {
              category: 'Product page related products',
              label: $(this).text().trim()
            },
            {
              integrations: {
                woopra: true
              }
            }
          )
        })
      }

      addTracking($('#prod-suggestions a'), 'Clicked We Also Suggest product')
      addTracking($products.find('a'), 'Clicked Customers Also Viewed product')
    }
  })
}
